import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import { findByAlunoCodigo } from "./api-aluno-responsavel";
import { errorMessage } from "../../util/ConfirmAlertUtil";
import Loading from "../UI/Loading";

const AlunoResponsavelTable = ({ aluno }) => {
  const [alunosResponsavel, setAlunosResponsavel] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const codAluno = aluno?.codigo;

  useEffect(() => {
    if (!codAluno) return undefined;
    let active = true;
    setIsLoading(true);
    findByAlunoCodigo(codAluno)
      .then((data) => {
        if (!active || !data) return;
        if (data.error) {
          errorMessage(data.message);
        } else if (Array.isArray(data)) {
          setAlunosResponsavel(data);
        }
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, [codAluno]);

  if (isLoading) {
    return (
      <Box py={4}>
        <Loading size={28} description="Carregando responsáveis..." />
      </Box>
    );
  }

  if (alunosResponsavel.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" textAlign="center" py={4}>
        Nenhum responsável vinculado a este aluno.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Table size="small" aria-label="Responsáveis do aluno">
        <TableHead>
          <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
            <TableCell>Responsável</TableCell>
            <TableCell>E-mail</TableCell>
            <TableCell>Parentesco</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {alunosResponsavel.map((ar) => (
            <TableRow key={ar.codigo}>
              <TableCell>{ar.usuario?.nome}</TableCell>
              <TableCell>{ar.usuario?.email}</TableCell>
              <TableCell>{ar.parentesco?.descricao ?? "--"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AlunoResponsavelTable;
